export default __webpack_public_path__ + "static/media/project6.be41173d.jpg";